import SearchBar from "../components/SearchBar";
import "./ProcurementHeader.css";

export default function ProcurementHeader({ onMenuClick }) {
  return (
    <header className="procurement-header">
      <div className="header-actions">
        <SearchBar onMenuClick={onMenuClick} />
      </div>
    </header>
  );
}
